import axios from "axios";
import { ApiResponse } from "@api/apiRequest";
import { tpApi } from "@api/instances";
import { UserResponse } from "@appTypes/index";
import rollbar, { LogMetadata } from "@utils/rollbar";

const getTpUser = async (signal?: AbortSignal): Promise<ApiResponse<UserResponse>> => {
  try {
    const response = await tpApi.get<UserResponse>("/users/v3/user", { signal, requireAuth: true });
    return { data: response.data, success: true, error: "" };
  } catch (e) {
    if (axios.isCancel(e)) {
      return { data: null, success: false, error: "AbortError" };
    }
    const err = e instanceof Error ? e : new Error("Unknown error");
    const meta: LogMetadata = { endpoint: "/users/v3/user", method: "GET" };
    rollbar.error(err, meta);
    return { data: null, success: false, error: "Error fetching user" };
  }
};

export default getTpUser;
